/* cart-drawer-subs.js
 * Cart drawer: Subscribe & Save CTA + selling plan dropdown
 * – Button shows BASE product price (not cart-discounted) + actual subscription price
 * – Subscription price is calculated from product selling_plan_groups
 * – Adds USP row: "Save with recurring delivery • Cancel anytime • Free shipping"
 * – Hides subscribe button when subscription price is 0 or no selling plan
 */

var CAD11Help = {
  cartCache: null,
  productCache: {},

  // ---- Data helpers ----
  loadCart: function () {
    if (CAD11Help.cartCache) return Promise.resolve(CAD11Help.cartCache);

    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        CAD11Help.cartCache = cart;
        return cart;
      });
  },

  loadProduct: function (handle) {
    if (CAD11Help.productCache[handle]) return Promise.resolve(CAD11Help.productCache[handle]);

    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        CAD11Help.productCache[handle] = product;
        return product;
      });
  },

  // Apply Shopify selling plan price_adjustment to a base price (in cents)
  applyPriceAdjustment: function (baseCents, adjustment) {
    if (!adjustment) return baseCents;

    if (adjustment.value_type === 'percentage') {
      // value is a percentage discount, e.g. 15
      return Math.round(baseCents * (100 - adjustment.value) / 100);
    }

    if (adjustment.value_type === 'fixed_amount') {
      // value is cents off
      return Math.max(0, baseCents - adjustment.value);
    }

    if (adjustment.value_type === 'price') {
      // value is the final price in cents
      return adjustment.value;
    }

    return baseCents;
  },

  /**
   * Get prices for a line using BASE product price:
   * - regularCents: base product price (variant.price) – NOT cart-discounted
   * - subscriptionCents: base price with selling plan price_adjustment applied
   * - sellingPlanId: plan used for the CTA (first group, first plan)
   */
  getLinePricesWithSubscription: function (lineIndex, handle) {
    return Promise.all([
      CAD11Help.loadCart(),
      CAD11Help.loadProduct(handle),
    ]).then(function (results) {
      var cart = results[0];
      var product = results[1];
      if (!cart || !product) return null;

      // cart.js items are 0-based; data-item-index is 1-based
      var line = cart.items[lineIndex - 1];
      if (!line) return null;

      var variantId = line.variant_id;
      var variant = product.variants.find(function (v) {
        return v.id === variantId;
      });
      if (!variant) return null;

      // BASE price from product (in cents) – this is what you want to show as "36"
      var baseCents = variant.price;

      var groups = product.selling_plan_groups || [];
      if (!groups.length || !groups[0].selling_plans.length) {
        // no selling plan available
        return null;
      }

      // For the CTA we mirror your original logic:
      // use first selling_plan of first selling_plan_group
      var sellingPlan = groups[0].selling_plans[0];
      var adjustment = (sellingPlan.price_adjustments && sellingPlan.price_adjustments[0]) || null;

      var subscriptionCents = CAD11Help.applyPriceAdjustment(baseCents, adjustment);

      return {
        regularCents: baseCents,            // 36.00 → shown on left
        subscriptionCents: subscriptionCents, // e.g. 30.60 → shown on right
        sellingPlanId: sellingPlan.id,
      };
    });
  },

  formatMoney: function (cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    var value = (cents / 100).toFixed(2);
    return value;
  },

  // ---- Event handlers ----
  addEvents: function () {
    document.addEventListener('click', function (e) {
      // "Subscribe & Save" button
      var btnSubs = e.target.closest('.cart-item-subscribe-btn');
      if (btnSubs) {
        btnSubs.classList.add('btn--loading');
        var item = btnSubs.closest('.cart__item');
        var lineIndex = parseInt(item.getAttribute('data-item-index'), 10);
        var handle = item
          .querySelector('.cart__item__title a')
          .getAttribute('href')
          .split('?')[0]
          .split('/')
          .pop();

        // Prefer the selling_plan id we already used for pricing, if present
        var presetPlanId = btnSubs.getAttribute('data-selling-plan-id');
        var qty = item.querySelector('.cart__quantity .cart__quantity-field').value || 1;

        if (presetPlanId) {
          CAD11Help.setSellingPlan(lineIndex, parseInt(presetPlanId, 10), qty);
        } else {
          CAD11Help.updateToSellingPlan(lineIndex, handle, item);
        }
      }

      // Open/close dropdown
      var btnSubsDropdown = e.target.closest('.cis__trigger');
      var allDropdowns = document.querySelectorAll('.cart-item-subscribe-dropdown');
      if (btnSubsDropdown) {
        var dropdown = btnSubsDropdown.closest('.cart-item-subscribe-dropdown');
        if (dropdown.classList.contains('open')) {
          dropdown.classList.remove('open');
        } else {
          dropdown.classList.add('open');
          // lazy-load selling plans
          if (dropdown.querySelectorAll('.cis__option').length === 0) {
            var itemOnCart = btnSubsDropdown.closest('.cart__item');
            var lineIndexOnCart = parseInt(itemOnCart.getAttribute('data-item-index'), 10);
            var handleOnCart = itemOnCart
              .querySelector('.cart__item__title a')
              .getAttribute('href')
              .split('?')[0]
              .split('/')
              .pop();
            CAD11Help.pullSellingPlan(lineIndexOnCart, handleOnCart, itemOnCart, btnSubsDropdown);
          }
        }
        // close others
        allDropdowns.forEach(function (d) {
          if (d !== dropdown) d.classList.remove('open');
        });
        return;
      }

      // Close dropdowns on outside click
      allDropdowns.forEach(function (d) {
        if (!d.contains(e.target)) {
          d.classList.remove('open');
        }
      });

      // Select selling plan option
      var btnSubsDropdownOption = e.target.closest('.cis__option');
      if (btnSubsDropdownOption) {
        var cartItem = btnSubsDropdownOption.closest('.cart__item'),
          cartDropdown = btnSubsDropdownOption.closest('.cart-item-subscribe-dropdown');
        var cartLineIndex = parseInt(cartItem.getAttribute('data-item-index'), 10),
          sellingId = parseInt(btnSubsDropdownOption.getAttribute('data-id'), 10),
          active = btnSubsDropdownOption.getAttribute('data-active'),
          qty = cartItem.querySelector('.cart__quantity .cart__quantity-field').value || 1;

        if (active === 'false') {
          CAD11Help.setSellingPlan(cartLineIndex, sellingId, qty);
          cartDropdown.classList.add('changing-subscribe-option');
        }
        cartDropdown.classList.remove('open');
      }
    });
  },

  // Fallback if button doesn't have data-selling-plan-id
  updateToSellingPlan: function (lineIndex, handle, item) {
    var qty = item.querySelector('.cart__quantity .cart__quantity-field').value || 1;
    fetch('/products/' + handle + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var sellingPlans = data.selling_plan_groups;
        if (sellingPlans && sellingPlans.length > 0) {
          CAD11Help.setSellingPlan(lineIndex, sellingPlans[0].selling_plans[0].id, qty);
        }
      });
  },

  pullSellingPlan: function (lineIndex, handle, item, btnSubsDropdown) {
    fetch('/products/' + handle + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var sellingPlans = data.selling_plan_groups;
        if (sellingPlans && sellingPlans.length > 0) {
          var activeSellingPlan = parseInt(
            btnSubsDropdown.querySelector('.cis__label').getAttribute('data-id'),
            10
          );
          var menu = item.querySelector('.cart-item-subscribe-wrap .cis__menu');
          if (!menu) return;

          menu.classList.add('loaded-selling-plan');
          sellingPlans.forEach(function (subPlan) {
            var optName = (subPlan.selling_plans[0].options[1].value.replace('-', ' ')).trim();
            if (optName === '2 week') {
              optName = '2 weeks';
            }
            menu.insertAdjacentHTML(
              'beforeend',
              '<li class="cis__option" aria-selected="false" data-active="' +
                (subPlan.selling_plans[0].id === activeSellingPlan ? 'true' : 'false') +
                '" data-id="' +
                subPlan.selling_plans[0].id +
                '">Deliver every ' +
                optName +
                '</li>'
            );
          });
        }
      });
  },

  setSellingPlan: function (line, sellingPlanId, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, selling_plan: sellingPlanId, quantity: qty }),
    }).then(function () {
      // clear cache so next time we fetch fresh data
      CAD11Help.cartCache = null;

      var cartItems = document.querySelector('cart-items');
      if (cartItems) {
        return cartItems.getCart();
      }
    });
  },

  // kept in case you use them elsewhere
  getCurrencySymbol: function (priceText) {
    return priceText.trim().match(/[^0-9.,]/)?.[0] || '';
  },

  getDiscountedPrice: function (priceText, discountPercent) {
    var numericValue = parseFloat(priceText.replace(/[^0-9.]/g, ''));
    if (isNaN(numericValue)) return priceText;
    var discountMultiplier = 1 - discountPercent / 100;
    return (numericValue * discountMultiplier).toFixed(2);
  },

  checkCartHasSubs: function () {
    var cart = document.querySelector('#cart-drawer');
    if (!cart) return;

    var cartItems = cart.querySelectorAll('.drawer__items > .cart__item');
    if (cartItems.length === 0) return;

    cartItems.forEach(function (item) {
      var titleLink = item.querySelector('.cart__item__title > a');
      if (!titleLink) return;

      var handle = titleLink.getAttribute('href').split('?')[0].split('/').pop();

      // Exclusions (bundle/system/etc.)
      if (
        handle.indexOf('-bundle') !== -1 ||
        handle.indexOf('-system') !== -1 ||
        handle.indexOf('-bottle') !== -1 ||
        handle === 'cadence-race-peach' ||
        handle === 'cadence-race-cherry'
      ) {
        return;
      }

      if (item.querySelectorAll('.cart-item-subscribe-wrap').length === 0) {
        item.insertAdjacentHTML('beforeend', '<div class="cart-item-subscribe-wrap"></div>');
      }

      item.classList.add('item-has-subscribe-option');

      var sellingPlan = item.querySelector('.cart__item__selling-plan');
      var wrap = item.querySelector('.cart-item-subscribe-wrap');

      if (sellingPlan) {
        // Already subscribed → show dropdown instead of button
        if (wrap.querySelectorAll('.cart-item-subscribe-dropdown').length === 0) {
          var planType = '1 month';
          if (sellingPlan.textContent.toLowerCase().indexOf('2 week') !== -1) {
            planType = '2 weeks';
          }

          var link = titleLink.getAttribute('href');
          var url = new URL(link, window.location.origin);
          var sellingPlanId = url.searchParams.get('selling_plan');

          wrap.insertAdjacentHTML(
            'afterbegin',
            '<div class="cart-item-subscribe-dropdown" data-dropdown>' +
              '  <button class="cis__trigger" aria-haspopup="listbox" aria-expanded="false">' +
              '    <span class="cis__label" data-id="' +
              sellingPlanId +
              '">Deliver every ' +
              planType +
              '</span>' +
              '    <span class="cis__chevron-wrap">' +
              '      <svg class="cis__chevron" xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none"><path d="M0 0L5.34558 5.34558L10.6912 0H0Z" fill="black" fill-opacity="0.3"/></svg>' +
              '    </span>' +
              '  </button>' +
              '  <ul class="cis__menu" role="listbox" tabindex="-1"></ul>' +
              '</div>'
          );
        }
      } else {
        // Not subscribed → show BASE price + subscription price
        item.querySelector('.cart-item-subscribed')?.remove();

        if (wrap.querySelectorAll('.cart-item-subscribe-btn').length === 0) {
          var lineIndex = parseInt(item.getAttribute('data-item-index'), 10);

          CAD11Help.getLinePricesWithSubscription(lineIndex, handle).then(function (pricing) {
            if (!pricing) return;
            if (!pricing.regularCents || !pricing.subscriptionCents) return;
            if (pricing.subscriptionCents <= 0) return;

            var regularText = CAD11Help.formatMoney(pricing.regularCents);       // e.g. $36.00
            var subsText = CAD11Help.formatMoney(pricing.subscriptionCents);     // e.g. $30.60

            // Element may have been removed / re-rendered meanwhile
            var wrapNow = item.querySelector('.cart-item-subscribe-wrap');
            if (!wrapNow || wrapNow.querySelector('.cart-item-subscribe-btn')) return;

            wrapNow.insertAdjacentHTML(
              'beforeend',
              '<button class="cart-item-subscribe-btn" data-selling-plan-id="' + pricing.sellingPlanId + '">' +
                '  <span><strong>Subscribe &amp; Save</strong></span>' +
                '  <span class="cart-item-subs-price-wrap">' +
                '    <span class="cart-item-price">' + regularText + '</span>' +   // BASE price
                '    <span class="cart-item-subs-price">' + subsText + '</span>' + // SUB price
                '    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0.574375 10.6251H16.8729L13.123 14.3749L14.0069 15.2588L19.2656 10.0001L14.0069 4.74137L13.123 5.62523L16.8729 9.37512H0.574375V10.6251Z" fill="white"/></svg>' +
                '  </span>' +
                '</button>'
            );
          });
        }
      }

      // USP row: Save • Cancel anytime • Free shipping
      if (item.querySelectorAll('.drawer-subs-usp').length === 0) {
        item.insertAdjacentHTML(
          'beforeend',
          '<div class="drawer-subs-usp">' +
            '  <span class="drawer-subs-usp-item">Save with recurring delivery</span>' +
            '  <span class="drawer-subs-usp-item drawer-subs-usp-item-divider">•</span>' +
            '  <span class="drawer-subs-usp-item">Cancel anytime.</span>' +
            '</div>'
        );
      }
    });
  },
};

// Init on cart drawer
(function initCartSubs() {
  var cartDrawer = document.querySelector('#cart-drawer');
  if (cartDrawer) {
    CAD11Help.checkCartHasSubs();

    var cartFooter = cartDrawer.querySelector('.drawer__foot');
    if (cartFooter) {
      var mutationCart = new MutationObserver(function () {
        // reset cart cache so we always fetch fresh data after cart changes
        CAD11Help.cartCache = null;
        CAD11Help.checkCartHasSubs();
      });
      mutationCart.observe(cartFooter, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }

    CAD11Help.addEvents();
  } else {
    setTimeout(initCartSubs, 50);
  }
})();
